import { v4 as uuidv4 } from 'uuid';

/**
 * The recommend way to generate this id is using the 'useId' function
 * from @uifabric/react-hooks but at the moment this runs int a couple
 * problems. First, it would mean taking a direct dependency on that
 * package just for the utility function. We're already making it
 * difficult for partners to integrate with this ux without adding more
 * package constraints. Second, this function runs inside of the
 * OverflowSet component which isn't a React hook and useId can only be
 * used inside a hook. We could probably make this work by converting this
 * button to be a functional component but that's a pretty sizable
 * refactor of this file.
 * @returns unique tooltip identifier
 */
export const generateTooltipId = (): string => {
  return `TooltipId-${uuidv4()}`;
};
